export default "__VITE_ASSET__wfwoYcej__"